var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',{staticClass:"text-center"},[_c('h1',[_vm._v(_vm._s(_vm.$t('global.pageNotFound')))]),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.back()}}},[_vm._v(_vm._s(_vm.$t('global.back')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }